<template>
    <div class="">
        <h5 class="pb-2 mb-4 border-b border-b-gray-300 text-lg">Live</h5>
        <div class="flex flex-wrap gap-8 mb-10">
            <room-card
                v-for="room in liveRooms"
                :key="room.room_id"
                :delete-api="deleteApi"
                :room="room"
                :team-id="teamId"
                :update-api="updateApi"
                :live-api="liveApi"
                :live-only="true"
                :href="
                    !isProduction
                        ? `${hrefPrefix}?code=${room.room_code}`
                        : undefined
                "
                :href-new="`${hrefNewPrefix}?code=${room.room_code}`"
                :available-tags="availableTags"
                :can-edit-category="!isFree ? 'true' : undefined"
                :can-manage="canManage ? 'true' : undefined"
            >
            </room-card>
            <div
                v-if="liveRooms.length === 0"
                class="text-gray-500 w-full my-10"
            >
                No Live Rooms
            </div>
        </div>

        <h5 class="pb-2 mb-4 border-b border-b-gray-300 text-lg">Not Live</h5>
        <div class="flex flex-wrap gap-8">
            <room-card
                v-for="room in emptyRooms"
                :key="room.room_id"
                :delete-api="deleteApi"
                :room="room"
                :team-id="teamId"
                :update-api="updateApi"
                :live-api="liveApi"
                :href="
                    !isProduction
                        ? `${hrefPrefix}?code=${room.room_code}`
                        : undefined
                "
                :href-new="`${hrefNewPrefix}?code=${room.room_code}`"
                :available-tags="availableTags"
                :can-edit-category="!isFree ? 'true' : undefined"
                :can-manage="canManage ? 'true' : undefined"
            >
            </room-card>
            <div
                v-if="emptyRooms.length === 0"
                class="text-gray-500 w-full my-10"
            >
                No Empty Rooms
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import axios from "axios";

const props = defineProps({
    initialLiveRooms: {
        type: Array,
        required: true,
    },
    initialEmptyRooms: {
        type: Array,
        required: true,
    },
    availableTags: {
        type: Array,
        required: true,
    },
    deleteApi: {
        type: String,
        required: true,
    },
    teamId: {
        type: [String, Number],
        required: true,
    },
    updateApi: {
        type: String,
        required: true,
    },
    liveApi: {
        type: String,
        required: true,
    },
    isFree: {
        type: Boolean,
        default: false,
    },
    canManage: {
        type: Boolean,
        default: false,
    },
    isProduction: {
        type: Boolean,
        default: false,
    },
    hrefPrefix: {
        type: String,
        required: true,
    },
    hrefNewPrefix: {
        type: String,
        required: true,
    },
    fetchUrl: {
        type: String,
        required: true,
    },
});

const liveRooms = ref([...props.initialLiveRooms]);
const emptyRooms = ref([...props.initialEmptyRooms]);
let refreshInterval = null;

const fetchMeetings = async () => {
    try {
        const response = await axios.get(props.fetchUrl, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            },
        });
        if (response.data) {
            if (response.data.liveRooms) {
                liveRooms.value = response.data.liveRooms;
            }
            if (response.data.emptyRooms) {
                emptyRooms.value = response.data.emptyRooms;
            }
        }
    } catch (error) {
        console.error("Failed to fetch meetings:", error);
    }
};

onMounted(() => {
    refreshInterval = setInterval(fetchMeetings, 10000); // 10 seconds
});

onUnmounted(() => {
    if (refreshInterval) {
        clearInterval(refreshInterval);
    }
});
</script>
